'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishAllMessagesInHistoryToChannel = undefined;

var _getPubSubMessage = require('conversations-schema/unpublished-messages/operators/getPubSubMessage');

var _getMessages = require('conversations-schema/thread-history/operators/getMessages');

var _hasMessages = require('conversations-schema/thread-history/operators/hasMessages');

var _publishMessageToConversation = require('../../actions/PublishActions/publishMessageToConversation');

var _getStubbedThreadHistory = require('../../stubbed-thread-history/selectors/getStubbedThreadHistory');

var publishAllMessagesInHistoryToChannel = exports.publishAllMessagesInHistoryToChannel = function publishAllMessagesInHistoryToChannel(_ref) {
  var channel = _ref.channel,
      threadId = _ref.threadId;
  return function (dispatch, getState) {
    var history = (0, _getStubbedThreadHistory.getStubbedThreadHistory)(getState());

    if ((0, _hasMessages.hasMessages)(history)) {
      (0, _getMessages.getMessages)(history).forEach(function (message) {
        var pubSubMessage = (0, _getPubSubMessage.getPubSubMessage)(message);
        dispatch((0, _publishMessageToConversation.publishMessageToConversation)({
          channel: channel,
          message: pubSubMessage,
          threadId: threadId
        }));
      });
    }
  };
};